module.exports = __webpack_public_path__ + "fonts/MyriadPro-Light.ddd72a6.woff2";